import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCardModule } from "@angular/material/card";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { ChartJsContainerComponent } from "@tylertech/chart-js";
import { ChartingModule } from "@tylertech/charting-module";
import { CommandsModule } from "@tylertech/commands-module";
import { CommonComponentsModule } from "@tylertech/common-components-module";
import { CoreModule } from "@tylertech/core-module";
import { CustomViewModule } from "@tylertech/custom-view";
import { InfoCardModule } from "@tylertech/info-card-module";
import { LgdTypeAheadModule } from "@tylertech/lgd-reactive-forms";
import { SearchModule } from "@tylertech/search-module";
import
{
    BudgetedPositionsChartComponent,
    HumanResourcesEmployeeTaskCompletionChartComponent,
    OpenEnrollmentChartComponent,
    OpenEnrollmentCompleteChartComponent,
    OvertimeUsageChartComponent,
    SickLeaveChartComponent,
    TurnoverChartComponent,
} from "./components/charts";
import { EmployeeLookupComponent } from "./components/employeeLookup";
import
{
    EmployeeESSUserLookupService,
    EmployeeManagerService,
    EmployeePayHistoryService,
    EmployeePhotoService,
    EmployeeRetirementService,
    EmployeeSearchService,
    EmployeeStatusLookupService,
    EmployeeTasksManagerService,
    HRDepartmentLookupService,
    JobTitleLookupService,
    MetadataExampleService,
    OpenEnrollmentChartService,
    PersonnelActionRequestService,
    PositionService,
    TerminationCodeLookupService,
    WorksiteLookupService,
} from "./services";

const angularModules = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule
];

const angularMaterialModules = [MatCardModule];

const lgdModules = [
    CoreModule,
    CommandsModule,
    CustomViewModule
        .withComponents(
            /* eslint-disable @typescript-eslint/naming-convention */
            {
                "payroll-open-enrollment-chart": OpenEnrollmentChartComponent,
                "payroll-budgeted-positions-chart": BudgetedPositionsChartComponent,
                "human-resources-employee-task-completion-chart": HumanResourcesEmployeeTaskCompletionChartComponent,
                "payroll-overtime-usage-chart": OvertimeUsageChartComponent,
                "payroll-sick-leave-chart": SickLeaveChartComponent,
                "payroll-turnover-chart": TurnoverChartComponent,
            }
            /* eslint-enable @typescript-eslint/naming-convention */
        ),
    CommonComponentsModule,
    LgdTypeAheadModule,
    ChartJsContainerComponent,
    ChartingModule,
    SearchModule,
    InfoCardModule
];

const components = [
    HumanResourcesEmployeeTaskCompletionChartComponent,
    EmployeeLookupComponent,
    BudgetedPositionsChartComponent,
    OpenEnrollmentChartComponent,
    OpenEnrollmentCompleteChartComponent,
    OvertimeUsageChartComponent,
    SickLeaveChartComponent,
    TurnoverChartComponent,
];
@NgModule({
    imports: [
        ...angularModules,
        ...angularMaterialModules,
        ...lgdModules
    ],
    declarations: components,
    exports: components,
    providers: [
        EmployeeESSUserLookupService,
        EmployeeManagerService,
        EmployeePayHistoryService,
        EmployeePhotoService,
        EmployeeRetirementService,
        EmployeeSearchService,
        EmployeeStatusLookupService,
        EmployeeTasksManagerService,
        HRDepartmentLookupService,
        JobTitleLookupService,
        MetadataExampleService,
        OpenEnrollmentChartService,
        PersonnelActionRequestService,
        PositionService,
        TerminationCodeLookupService,
        WorksiteLookupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PersonnelModule { }
